import React from "react";
import { countries } from "@/utils/countries";

export const NameCell = ({
  language,
  firstName,
  lastName,
}: {
  language: string | null;
  firstName: string | null;
  lastName: string | null;
}) => (
  <div className="text-center flex items-center justify-center gap-2">
    <span className="text-lg">
      {(language && countries.find((c) => c.code === language)?.flag) || null}
    </span>
    <span>{firstName + " " + lastName}</span>
  </div>
);
